define('fukit/behavior/confirm.model.destroy.on.press.behavior',['require','exports','module','./confirm.model.destroy.on.event.behavior'],function(require, exports, module) {
  module.exports = require('./confirm.model.destroy.on.event.behavior');
});

